<template>
  <div class="col-md-12 text-center">
    <a
      :href="'https://' + editorUrl + '/new/' + (productDetail !== null ? '?productType='+productDetail : '')"
      class="btn btn-design-poster"
    >{{buttonText}}</a>
  </div>
</template>

<script>
export default {
  name: "PosterButton",
  data() {
    return {
      editorUrl: 'editor.' + process.env.VUE_APP_ROOT_DOMAIN
    };
  },
  props: {
    buttonText: {
      type: String,
    },
    productDetail: {
      type: String,
    },
  },
};
</script>
